import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../../../../../../../Translations';
import { ExperienceResource } from '../../../../../../../../../../../../../Types';
import CompetencyLabel from '../../../../../../../../../../../../CompetencyLabel';
import { fromEmpty } from 'maybeasy';

export interface Props {
  resource: ExperienceResource;
}

const Competencies: React.FC<Props> = ({ resource }) =>
  fromEmpty(resource.payload.competencies)
    .map((competencies) => (
      <div className="flex flex-col px-10 pt-8 mb-5">
        <div className="mb-2 text-sm font-medium">
          <T kind={'Competencies'} />
        </div>
        <div className="flex flex-wrap gap-x-2 gap-y-2">
          {competencies.map((competency) => (
            <CompetencyLabel competency={competency} key={competency.payload.id} />
          ))}
        </div>
      </div>
    ))
    .getOrElse(() => <></>);

export default observer(Competencies);
